/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest,
  TrainWithMeModulesClientsDtosResponsesGetPersonalTrainerResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPersonaltrainerId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetPersonalTrainerResponse>(
      {url: `/personaltrainer/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetPersonaltrainerIdQueryKey = (id: number,) => {
    return [
    `/personaltrainer/${id}`
    ] as const;
    }


export const getGetPersonaltrainerIdQueryOptions = <TData = Awaited<ReturnType<typeof getPersonaltrainerId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonaltrainerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonaltrainerIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonaltrainerId>>> = ({ signal }) => getPersonaltrainerId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonaltrainerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonaltrainerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonaltrainerId>>>
export type GetPersonaltrainerIdQueryError = ErrorType<unknown>


export function useGetPersonaltrainerId<TData = Awaited<ReturnType<typeof getPersonaltrainerId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonaltrainerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonaltrainerId>>,
          TError,
          Awaited<ReturnType<typeof getPersonaltrainerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonaltrainerId<TData = Awaited<ReturnType<typeof getPersonaltrainerId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonaltrainerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonaltrainerId>>,
          TError,
          Awaited<ReturnType<typeof getPersonaltrainerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonaltrainerId<TData = Awaited<ReturnType<typeof getPersonaltrainerId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonaltrainerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonaltrainerId<TData = Awaited<ReturnType<typeof getPersonaltrainerId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonaltrainerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonaltrainerIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchPersonaltrainerId = (
    id: number,
    trainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetPersonalTrainerResponse>(
      {url: `/personaltrainer/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest, signal
    },
      options);
    }




export const getPatchPersonaltrainerIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPersonaltrainerId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPersonaltrainerId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest>}, TContext> => {

const mutationKey = ['patchPersonaltrainerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPersonaltrainerId>>, {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPersonaltrainerId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchPersonaltrainerIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchPersonaltrainerId>>>
    export type PatchPersonaltrainerIdMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest> | undefined
    export type PatchPersonaltrainerIdMutationError = ErrorType<unknown>

    export const usePatchPersonaltrainerId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPersonaltrainerId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPersonaltrainerId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchPersonalTrainerRequest>},
        TContext
      > => {
      return useMutation(getPatchPersonaltrainerIdMutationOptions(options), queryClient);
    }
